import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, FormHelperText,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { createMatInwardEntry } from '../../Store/PHPSlice/MatInward';
import { errorStyles } from '../../Utils/table';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';



const MatInwardEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        materialNm: ' ',
        inwardNo: "",
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const materials = useSelector((state) => state.MaterialData.material || { data: [] });

    useEffect(() => {
        dispatch(fetchMaterialData())
    }, [dispatch]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleAddMaterial = () => {
        const selectedMaterial = materials.data.find(item => item.ID === formData.materialNm);
        if (selectedMaterial) {
            setTableRows([
                ...tableRows,
                {
                    id: tableRows.length + 1,
                    materialId: selectedMaterial.ID,
                    materialNm: selectedMaterial.materialNm,
                    description: selectedMaterial.description || '',
                    size: selectedMaterial.size || '',
                    packets: selectedMaterial.packets || '',
                    packetqty: selectedMaterial.packetqty || '',
                    totqty: selectedMaterial.totqty || '',
                    stkqty: ''
                }
            ]);
        }

        setFormData({
            ...formData,
            materialNm: ''
        })
    };

    // const handleInputChange = (index, field, value) => {
    //     const updatedRows = tableRows.map((row, i) => {
    //         if (i === index) {
    //             return { ...row, [field]: value.toUpperCase() };
    //         }
    //         return row;
    //     });
    //     setTableRows(updatedRows);
    // };

    const handleInputChange = (index, field, value) => {
        const updatedRows = tableRows.map((row, i) => {
            if (i === index) {
                let newRow = { ...row, [field]: value };

                const packets = parseFloat(newRow.packets) || 0;
                const packetqty = parseFloat(newRow.packetqty) || 0;
                const totqty = parseFloat(newRow.totqty) || 0;

                // CASE 1: packets changed → update totqty
                if (field === "packets") {
                    newRow.totqty = packets * packetqty;
                }

                // CASE 2: packetqty changed → update totqty
                else if (field === "packetqty") {
                    newRow.totqty = packets * packetqty;
                }

                // CASE 3: totqty changed → update packetqty = totqty / packets
                else if (field === "totqty") {
                    if (packets > 0) {
                        newRow.packetqty = (totqty / packets).toFixed(2);
                    } else {
                        newRow.packetqty = 0;
                    }
                }

                return newRow;
            }
            return row;
        });

        setTableRows(updatedRows);
    };

    const handleCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };

    const handleDeleteMaterial = () => {
        setTableRows(tableRows.filter(row => !selectedRows.includes(row.id)));
        setSelectedRows([]);
    };

    // const validate = () => {
    //     const newErrors = {};
    //     // if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
    //     return newErrors;
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        if (tableRows.length > 0) {

            setLoading(true);

            var finalObject = {
                dt: formData.dt,
                inwardNo: formData.inwardNo,
                matId: tableRows.map(row => row.materialId),
                pkt: tableRows.map(row => row.packets),
                packetqty: tableRows.map(row => row.packetqty),
                totqty: tableRows.map(row => row.totqty),
                qty: tableRows.map(row => row.stkqty),
                userId: formData.userId
            };

            try {
                const result = await dispatch(createMatInwardEntry(finalObject)).unwrap();
                console.log('POST request successful!', result);
                alert("Material Inward Added");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }

        } else {
            alert("Select Material Name & fill the Table");

        }

    };



    const dropdownlist = [

        {
            label: 'Material',
            id: 'materialNm',
            options: materials.data || [],
            value: formData.materialNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'materialNm', value: newValue ? newValue.ID : '' } }, 'materialNm'),
            getOptionLabel: (option) => `${option.materialNm}-${option.size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.materialNm
        },
    ];


    return (
        <>
            <Titlebar data={MaterialMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* Inward No */}
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="inwardNo">Inward No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id="inwardNo"
                                                    name="inwardNo"
                                                    type="text"
                                                    value={formData.inwardNo}
                                                    onChange={(e) =>
                                                        setFormData({ ...formData, inwardNo: e.target.value })
                                                    }
                                                    inputProps={{ style: styled.inputTable }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="materialNm">Material Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="materialNm"
                                                    id="materialNm"
                                                    name="materialNm"
                                                    value={formData.materialNm}
                                                    onChange={(e) => handleDropdownChange(e, 'materialNm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value=" ">Select an option</MenuItem>
                                                    {
                                                        materials.data.length > 0 ? materials.data.map((item, index) => (
                                                            <MenuItem value={item.ID}>{item.materialNm} - {item.size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                                {errors.materialNm && <FormHelperText style={errorStyles}>{errors.materialNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {dropdownlist?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        errors={drop.errors}
                                    />
                                ))
                                }


                                <Grid item xs={12} md={6}>
                                    <Button variant="contained" color="primary" onClick={handleAddMaterial} sx={{ mr: 2 }}>Add</Button>
                                    <Button variant="contained" color="primary" onClick={handleDeleteMaterial}>Delete</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ marginTop: '1%' }}>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Material Name</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Description</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Per Packet Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Inward Packet Qty</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Inward Qty</TableCell>

                                                        {/* <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Stock Qty</TableCell> */}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(row.id)}
                                                                    onChange={() => handleCheckboxChange(row.id)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{row.id}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.materialNm}
                                                                    onChange={(e) => handleInputChange(index, 'materialNm', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                /> */}

                                                                {row.materialNm}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.description}
                                                                    onChange={(e) => handleInputChange(index, 'description', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                /> */}

                                                                {row.description}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.size}
                                                                    onChange={(e) => handleInputChange(index, 'size', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                /> */}

                                                                {row.size}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    value={row.packets}
                                                                    onChange={(e) => handleInputChange(index, 'packets', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                /> */}
                                                                {row.packets}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    value={row.packetqty}
                                                                    onChange={(e) => handleInputChange(index, 'packetqty', e.target.value)}
                                                                    inputProps={{
                                                                        style: {
                                                                            ...styled.inputTable,
                                                                            color: "green",
                                                                            fontWeight: "bold"
                                                                        }
                                                                    }}
                                                                />

                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    value={row.totqty}
                                                                    onChange={(e) => handleInputChange(index, 'totqty', e.target.value)}
                                                                    InputProps={{

                                                                        style: { ...styled.inputTable, color: 'blue', fontWeight: 'bold' }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    value={row.stkqty}
                                                                    onChange={(e) => handleInputChange(index, 'stkqty', e.target.value)}
                                                                    inputProps={{ style: styled.inputTable }}
                                                                />
                                                            </TableCell> */}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MatInwardEntry;
